
import React, { useState } from 'react';
import { Container, Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FiPhone, FiMail } from 'react-icons/fi';
import { FiFacebook, FiInstagram, FiLinkedin } from 'react-icons/fi';
import { FaXTwitter } from 'react-icons/fa6';
import { FaTelegramPlane } from 'react-icons/fa';
import assets from '../assets/assets';

const Footer = () => {
  const [termsModal, setTermsModal] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);

  const toggleTerms = () => setTermsModal(!termsModal);
  const togglePrivacy = () => setPrivacyModal(!privacyModal);
const privacyPolicyContent = `
<p>This Privacy Policy (“Policy”) sets out the manner in which Sha tours (“Company”, “we”, “us”, or “our”) collects, uses, stores, processes, discloses, and protects Personal Information of individuals (“you”, “your”, “User”) who access our website, submit inquiries, or avail any travel-related services offered by us. By accessing our website or engaging our services, you acknowledge and agree to the terms of this Policy.
</p>
<h4><strong>1. DEFINITIONS</strong></h4>
<strong>For the purpose of this Policy:</strong>
<ul>
  <li><strong>“Personal Information”</strong> means any information that identifies or relates to an identifiable individual, including but not limited to name, contact details, passport information, travel preferences, and payment details.</li>
  <li><strong>“Sensitive Personal Data”</strong> includes passport numbers, financial information, health-related information (such as special assistance requirements), and any other information categorized as sensitive under applicable law.</li>
  <li><strong>“Processing”</strong> means any operation performed on Personal Information, including collection, storage, use, transfer, disclosure, or deletion.</li>
  <li><strong>“Third Parties”</strong> include airlines, hotels, transport providers, visa agents, insurance companies, payment gateways, and service providers engaged for delivering our services.</li>
</ul>

<h4><strong>2. SCOPE OF THE POLICY</strong></h4>
<ul>
  <li>This Policy applies to all individuals who interact with the Company through the website, inquiry forms, emails, phone calls, or in person.</li>
  <li>This Policy does not apply to third-party websites linked from our platform. Each external service provider may have its own privacy practices.</li>
</ul>

<h4><strong>3. INFORMATION WE COLLECT</strong></h4>

<h5><strong>3.1 Personal Information:</strong></h5>
<strong>We may collect the following information for the execution of our services:</strong>
<ul>
  <li>Full name, date of birth, gender;</li>
  <li>Contact number, email address, postal address;</li>
  <li>Passport, visa, and identification details;</li>
  <li>Emergency contact information;</li>
  <li>Travel preferences, special requirements, and service requests.</li>
</ul>

<h5><strong>3.2 Financial Information:</strong></h5>
<ul>
  <li>Payment method, billing details, and transaction-related information.</li>
  <li>We do not store complete credit / debit card details. All payments are processed through secure third-party gateways.</li>
</ul>

<h5><strong>3.3 Technical and Usage Data:</strong></h5>
<ul>
  <li>IP address, device information, browser type;</li>
  <li>Cookies, browsing patterns, website navigation data;</li>
  <li>Location information (if device settings permit).</li>
</ul>

<h5><strong>3.4 Information from Third Parties:</strong></h5>
<p>We may receive information from travel partners, payment processors, or affiliates for completing bookings or addressing service needs.</p>

<h4><strong>4. PURPOSE OF PROCESSING</strong></h4>
<strong>We process your information for the following purposes:</strong>
<ul>
  <li>To plan, customize, and confirm travel itineraries.</li>
  <li>To process payments, generate invoices, and maintain financial records.</li>
  <li>To coordinate bookings with airlines, hotels, transport companies, and other partners.</li>
  <li>To respond to inquiries, provide updates, and offer customer support.</li>
  <li>To comply with legal, regulatory, or governmental requirements.</li>
  <li>To improve user experience, website functionality, and service offerings.</li>
  <li>To send promotional communications, offers, or newsletters (only with consent).</li>
</ul>

<h4><strong>5. LEGAL BASIS FOR PROCESSING</strong></h4>
<strong>Processing of Personal Information is conducted on one or more of the following legal grounds:</strong>
<ul>
  <li>Your explicit consent.</li>
  <li>Performance of a contract or steps undertaken at your request prior to entering a contract.</li>
  <li>Compliance with legal obligations.</li>
  <li>Legitimate business interests, including enhancement of service efficiency, customer support, and operational improvement.</li>
</ul>

<h4><strong>6. DISCLOSURE OF INFORMATION</strong></h4>
<ul>
  <li>Your Personal Information may be disclosed strictly on a need-to-know basis to the following entities:
    <ul>
      <li>Airlines, hotels, transport providers, and destination management companies;</li>
      <li>Visa facilitation agencies, insurance providers, and travel partners;</li>
      <li>Payment gateway service providers;</li>
      <li>Technology vendors, IT support teams, and administrative service providers;</li>
      <li>Government authorities or law enforcement agencies when required by law.</li>
    </ul>
  </li>
  <li>We do not sell, trade, or lease your Personal Information to unrelated third parties for marketing purposes.</li>
</ul>

<h4><strong>7. INTERNATIONAL TRANSFER OF DATA</strong></h4>
<ul>
  <li>For outbound tours or bookings with international partners, your information may be transferred outside your home country.</li>
  <li>Such transfers shall be conducted in compliance with applicable data protection laws and with adequate safeguards.</li>
</ul>

<h4><strong>8. COOKIES AND TRACKING TECHNOLOGIES</strong></h4>
<ul>
  <li>Our website uses cookies and similar technologies to enhance user experience and analyze website performance.</li>
  <li>Users may disable cookies through browser settings; however, certain website features may become limited or unavailable.</li>
</ul>

<h4><strong>9. DATA SECURITY</strong></h4>
<ul>
  <li>We implement reasonable physical, electronic, and managerial safeguards to protect your information from unauthorized access, misuse, or alteration.</li>
  <li>While we strive to use commercially acceptable means to protect your data, we cannot guarantee absolute security due to inherent limitations of digital systems.</li>
  <li>Users are advised to maintain the confidentiality of their login credentials and exercise caution when submitting information online.</li>
</ul>

<h4><strong>10. DATA RETENTION</strong></h4>
<ul>
  <li>Personal Information shall be retained only for as long as necessary to fulfill the purposes stated in this Policy, unless a longer retention period is required by law.</li>
  <li>Once retention is no longer required, data shall be securely destroyed or anonymized.</li>
</ul>

<h4><strong>11. YOUR RIGHTS</strong></h4>
<strong>Subject to applicable laws, you may exercise the following rights:</strong>
<ul>
  <li>Right to access Personal Information.</li>
  <li>Right to request correction or updates.</li>
  <li>Right to withdraw consent for marketing or non-essential communication.</li>
  <li>Right to request deletion or restriction of processing (unless restricted by law).</li>
  <li>Right to data portability where applicable.</li>
  <li>Right to raise concerns regarding misuse of data.</li>
</ul>
<p>Requests may be submitted to the contact provided in Clause 15.</p>

<h4><strong>12. CHILDREN’S PRIVACY</strong></h4>
<ul>
  <li>Our services are not intended for individuals under 18 years without parental or guardian consent.</li>
  <li>We do not knowingly collect Personal Information of minors without lawful authorization.</li>
</ul>

<h4><strong>13. THIRD-PARTY LINKS</strong></h4>
<ul>
  <li>Our website may contain links to external websites.</li>
  <li>We are not responsible for the privacy practices, content, or policies of such third-party platforms.</li>
</ul>

<h4><strong>14. AMENDMENTS TO THIS POLICY</strong></h4>
<ul>
  <li>The Company reserves the right to modify, update, or revise this Policy at any time.</li>
  <li>The updated Policy shall be published on the website with a revised “Last Updated” date.</li>
  <li>Continued use of the website or services after such amendments constitutes acknowledgment and acceptance of the changes.</li>
</ul>

<h4><strong>15. CONTACT INFORMATION</strong></h4>
<strong>For inquiries, concerns, or requests relating to this Privacy Policy, please contact:</strong>
<p>
  Sha tours,
  Thiruvalluvar Extension Street,
  Ponmeni, Madurai – 625 016,
  Tamil Nadu, India.
  +91 96597 60606
  badusha@shatoursindia.com
  www.shatoursindia.com
</p>
`;

// You can now use privacyPolicyContent directly in your code, e.g., innerHTML = privacyPolicyContent;
const termsConditionsContent = `
<p>These Terms &amp; Conditions (“Terms”) constitute a legally binding agreement between Sha tours (“Company”, “we”, “us”, or “our”) and the traveller (“client”, “customer”, “you”, or “your”). By booking a tour, using our services, or accessing our website, you acknowledge that you have read, understood, and agreed to be bound by these Terms in full.</p>
<h4><strong>1. DEFINITIONS</strong></h4>
<p><strong>1.1 “Tour Package”</strong> refers to any combination of travel services including accommodation, transportation, sightseeing, meals, and other arrangements sold as a package.</p>
<p><strong>1.2 “Supplier”</strong> means airlines, hotels, transport operators, visa authorities, insurance companies, destination management companies, guides and third-party vendors.</p>
<p><strong>1.3 “Force Majeure”</strong> includes natural disasters, political disturbances, strikes, epidemics, government orders, and events beyond reasonable control.</p>
<p><strong>1.4 “FIT / Tailor-Made Tour”</strong> – A customized itinerary designed for individual travellers or private groups.</p>
<p><strong>1.5 “GIT / Group Tour”</strong> – A pre-designed itinerary operated with a minimum number of participants.</p>
<p><strong>1.6 “Booking”</strong> means reservation of any service provided by the Company.</p>
<p><strong>1.7 “Client Documents”</strong> refers to passports, visas, ID proofs, medical certificates, and any personal documents required for travel.</p>

<h4><strong>2. SCOPE OF SERVICES</strong></h4>
<strong>Our services may include:</strong>
<ul>
  <li>Domestic and International tour packages</li>
  <li>Hotel bookings, transfers, and sightseeing arrangements</li>
  <li>Airline ticketing and insurance</li>
  <li>Visa facilitation and documentation assistance</li>
  <li>Foreign exchange (forex) assistance through authorized partners</li>
  <li>Custom-designed itineraries</li>
</ul>
<p>The Company acts as an intermediary between the Traveller and Service Providers.</p>

<h4><strong>3. BOOKING PROCESS</strong></h4>
<p><strong>3.1</strong> Bookings become valid only after the Company receives the required booking deposit and sends a written confirmation.</p>
<strong>3.2 Acceptance of a booking is subject to:</strong> 
<ul>
  <li>Availability</li>
  <li>Receipt of applicable deposits</li>
  <li>Compliance with immigration and travel regulations</li>
</ul>
<p><strong>3.3</strong> All details provided by the client—names, passport numbers, travel dates, flight preferences, and accommodation preferences—must be accurate and match official documents.</p>
<p><strong>3.4</strong> Any errors or omissions may result in denial of services or additional charges, for which the client will be solely responsible.</p>
<p><strong>3.5</strong> The Company reserves the right to refuse bookings without assigning any reason.</p>

<h4><strong>4. PRICING, TAXES &amp; REVISIONS</strong></h4>
<p><strong>4.1</strong> All prices quoted are based on prevailing rates, taxes, exchange rates, and supplier costs at the time of quotation.</p>
<p><strong>4.2</strong> Prices may change due to fluctuations in currency value, changes in tax structures, surcharges imposed by airlines or hotels, or government directives.</p>
<p><strong>4.3</strong> Any increase shall be payable by the client prior to the commencement of the tour.</p>
<p><strong>4.4</strong> Promotional prices and discounts are subject to availability and may be withdrawn without notice.</p>

<h4><strong>5. PAYMENT TERMS</strong></h4>
<p><strong>5.1</strong> A booking is secured only after the specified advance payment is received.</p>
<p><strong>5.2</strong> Final payment must be made within the deadline mentioned in the invoice or booking confirmation.</p>
<strong>5.3 Prices are subject to change based on:</strong> 
<ul>
  <li>Fluctuations in foreign exchange rates</li>
  <li>Changes in airline or hotel pricing</li>
  <li>Government levies, taxes, fuel surcharges</li>
</ul>
<p><strong>5.4</strong> Failure to complete payment may result in automatic cancellation without refund.</p>
<p><strong>5.5</strong> Payments can be made via bank transfer, UPI, or approved payment channels.</p>
<p><strong>5.6</strong> All bank charges, transaction fees, and foreign exchange charges are borne by the client.</p>

<h4><strong>6. AMENDMENTS, CHANGES &amp; MODIFICATIONS</strong></h4>
<p><strong>6.1</strong> Requests for amendments must be submitted in writing.</p>
<p><strong>6.2</strong> All amendments are subject to availability and supplier policies.</p>
<p><strong>6.3</strong> Change fees, fare differences, and administrative charges may apply.</p>
<p><strong>6.4</strong> Reductions in group size, downgrades, or partial cancellations are treated as cancellations and standard cancellation charges will apply.</p>

<h4><strong>7. CANCELLATIONS &amp; REFUNDS</strong></h4>
<p><strong>7.1</strong> Cancellations must be communicated in writing via email.</p>
<p><strong>7.2</strong> Cancellation charges vary depending on the date of cancellation and supplier rules.</p>
<p><strong>7.3</strong> Refunds, if applicable, will be processed only to the original payment method.</p>
<strong>7.4 No refund will be provided for:</strong> 
<ul>
  <li>No-show or failure to report on time</li>
  <li>Unused services or missed tours</li>
  <li>Personal choice</li>
  <li>Medical issues</li>
  <li>Behavioural issues</li>
  <li>Early check-out or voluntary withdrawal</li>
  <li>Changes due to Force Majeure</li>
</ul>
<p><strong>7.5</strong> Refund timelines depend on airline, hotel, and supplier processing and may take between 15–60 working days.</p>

<h4><strong>8. TRAVEL DOCUMENTS &amp; COMPLIANCE</strong></h4>
<p><strong>8.1</strong> Clients must ensure possession of valid passports, visas, insurance, and mandatory travel documents.</p>
<p><strong>8.2</strong> The Company may provide guidance but is not responsible for processing delays, visa rejection, or incomplete documentation.</p>
<p><strong>8.3</strong> Any travel restriction, denial of boarding, deportation, or immigration issues arising due to non-compliance are the client’s sole responsibility.</p>

<h4><strong>9. HEALTH, FITNESS &amp; MEDICAL CONDITIONS</strong></h4>
<p><strong>9.1</strong> Clients must ensure they are medically fit to travel.</p>
<p><strong>9.2</strong> Any existing medical conditions must be declared at the time of booking.</p>
<p><strong>9.3</strong> Medical assistance overseas may be expensive; clients are advised to obtain travel insurance.</p>
<p><strong>9.4</strong> The Company is not responsible for health issues, injuries, illness, or accidents occurring during the tour.</p>

<h4><strong>10. SPECIAL REQUIREMENTS</strong></h4>
<p><strong>10.1</strong> Requests such as wheelchair access, adjoining rooms, meals, or dietary needs must be communicated during booking.</p>
<p><strong>10.2</strong> These requests cannot be guaranteed and depend solely on supplier availability.</p>
<p><strong>10.3</strong> Additional costs may apply for special arrangements.</p>

<h4><strong>11. BAGGAGE, PERSONAL BELONGINGS &amp; RESPONSIBILITY</strong></h4>
<p><strong>11.1</strong> Clients are solely responsible for their baggage and personal belongings.</p>
<p><strong>11.2</strong> The Company shall not be liable for loss, theft, or damage to baggage or valuables.</p>
<p><strong>11.3</strong> Airline baggage policies vary and must be checked by the client prior to travel.</p>

<h4><strong>12. SUPPLIER TERMS</strong></h4>
<p><strong>12.1</strong> All travel services are subject to supplier terms and conditions.</p>
<p><strong>12.2</strong> Any dispute, overbooking, cancellation, or service failure caused by suppliers is beyond the Company’s control.</p>
<p><strong>12.3</strong> Compensation or remedies, if any, will depend solely on supplier policies.</p>

<h4><strong>13. ITINERARY CHANGES &amp; TOUR OPERATIONS</strong></h4>
<p><strong>13.1</strong> The Company reserves the right to modify itineraries due to operational reasons, safety concerns, weather conditions, or supplier constraints.</p>
<p><strong>13.2</strong> Alternate arrangements of equal or similar value will be provided whenever possible.</p>
<p><strong>13.3</strong> No financial compensation shall be payable for itinerary or service changes.</p>

<h4><strong>14. BEHAVIOUR, CONDUCT &amp; SAFETY</strong></h4>
<strong>14.1 Travellers must:</strong> 
<ul>
  <li>Carry valid passports, visas, and identification</li>
  <li>Ensure compliance with immigration requirements</li>
  <li>Follow tour timings strictly</li>
</ul>
<p><strong>14.2</strong> Clients are expected to maintain discipline, respect local customs, and follow guide instructions.</p>
<p><strong>14.3</strong> Misconduct, illegal activity, intoxication, or aggressive behaviour may result in removal from the tour without refund.</p>
<p><strong>14.4</strong> The Company shall not be liable for consequences arising due to client negligence or misconduct.</p>

<h4><strong>15. FORCE MAJEURE</strong></h4>
<strong>15.1 The Company shall not be liable for events beyond its control, including but not limited to:</strong>
<ul>
  <li>Natural disasters</li>
  <li>Epidemics, pandemics</li>
  <li>Political unrest, terrorist activity</li>
  <li>Flight cancellations or delays</li>
  <li>Government restrictions</li>
  <li>Acts of God</li>
</ul>
<p><strong>15.2</strong> No refunds, reimbursements, or compensation will be issued for disruptions caused by Force Majeure.</p>

<h4><strong>16. LIABILITY LIMITATIONS</strong></h4>
<p><strong>16.1</strong> The Company acts as an intermediary and does not control airline, hotel, or transport services.</p>
<p><strong>16.2</strong> The Company’s liability is limited to the amount paid for the tour service booked.</p>
<strong>16.3 The Company shall not be liable for:</strong> 
<ul>
  <li>Injury, accident, illness, or death</li>
  <li>Loss of property or valuables</li>
  <li>Delays, overbooking, or service failures by suppliers</li>
  <li>Damages caused by third parties or circumstances beyond control</li>
</ul>

<h4><strong>17. TRAVEL INSURANCE</strong></h4>
<p><strong>17.1</strong> Travel insurance is strongly recommended and may be mandatory for certain destinations.</p>
<p><strong>17.2</strong> The Company is not responsible for the adequacy or validity of insurance purchased by the client.</p>

<h4><strong>18. VISA PROCESSING</strong></h4>
<h5><strong>18.1 Role of the Company</strong></h5>
<ul>
  <li>We provide assistance in submitting visa applications.</li>
  <li>We are not responsible for acceptance, rejection, or delays caused by embassies or consulates.</li>
</ul>
<h3><strong>18.2 Responsibilities of the Traveller</strong></h3>
<ul>
  <li>Provide accurate, complete documents.</li>
  <li>Attend personal interviews if required.</li>
  <li>Pay all consulate / visa fees.</li>
  <li>Acknowledge that visa approval is purely at the discretion of the issuing authority.</li>
</ul>
<h3><strong>18.3 Visa Rejection / Delay</strong></h3>
<strong>The Company is not liable for:</strong>
<ul>
  <li>Visa refusal</li>
  <li>Late approvals that affect travel</li>
  <li>Losses arising from denial of entry or immigration issues</li>
</ul>
<h3><strong>18.4 Non-Refundability</strong></h3>
<strong>If a visa is rejected or delayed:</strong>
<ul>
  <li>Tour payments are non-refundable</li>
  <li>Standard cancellation rules apply</li>
  <li>Airfare, hotel, and service provider charges cannot be recovered</li>
</ul>
<p><strong>18.5 Passport Validity</strong><br>Travellers must ensure their passport is valid for at least 6 months beyond travel dates.</p>

<h4><strong>19. FOREIGN EXCHANGE (FOREX) HANDLING</strong></h4>
<h6><strong>19.1 Forex Services</strong></h6>
<strong>Forex may be provided through:</strong>
<ul>
  <li>Authorized Money Changers</li>
  <li>Banks</li>
  <li>RBI-regulated partners</li>
</ul>
<h3><strong>19.2 Traveller Responsibilities</strong></h3>
<ul>
  <li>Submit all required KYC documents.</li>
  <li>Comply with RBI regulations and limits on foreign currency purchase.</li>
</ul>
<h3><strong>19.3 Limitations</strong></h3>
<strong>The Company:</strong>
<ul>
  <li>Does not guarantee exchange rates</li>
  <li>Is not responsible for shortages or unavailability</li>
  <li>Will not handle undeclared or illegal currency transactions</li>
</ul>
<p><strong>19.4 Liability</strong><br>Any forex handling is strictly at the Traveller’s request, and we assume no financial liability.</p>

<h4><strong>20. FIT (TAILOR-MADE TOUR) CLAUSES</strong></h4>
<h6><strong>20.1 Customization</strong></h6>
<strong>FIT services are personalized. Once an itinerary is approved:</strong>
<ul>
  <li>Subsequent changes may incur extra charges</li>
  <li>Availability cannot always be guaranteed</li>
</ul>
<p><strong>20.2 Responsibility for Timing</strong><br>Clients must manage their schedule. Missing a booked activity due to lateness is non-refundable.</p>
<p><strong>20.3 Individual Arrangements</strong><br>Transfers, activities, and timings are based on individual arrangements and may differ from standard group tours.</p>
<h4><strong>20.4 Local Assistance</strong></h4>
<strong>Support will be available via:</strong>
<ul>
  <li>24x7 helpline</li>
  <li>Local partners</li>
  <li>Emergency contact numbers</li>
</ul>
<h3><strong>20.5 Pricing</strong></h3>
<strong>FIT pricing varies based on:</strong>
<ul>
  <li>Seasonal rates</li>
  <li>Custom requests</li>
  <li>Preferred hotels and upgrades</li>
</ul>

<h4><strong>21. COMPLAINTS &amp; GRIEVANCES</strong></h4>
<p><strong>21.1</strong> Complaints must be reported immediately to the tour manager or local representative.</p>
<p><strong>21.2</strong> Post-travel complaints must be submitted within 7 days of return with supporting documents.</p>
<p><strong>21.3</strong> Resolution depends on supplier feedback and investigation.</p>

<h4><strong>22. WEBSITE USE &amp; CONTENT</strong></h4>
<p><strong>22.1</strong> All content on the Company’s website is for informational purposes.</p>
<p><strong>22.2</strong> Prices, itineraries, photographs, and descriptions are indicative and subject to change.</p>
<p><strong>22.3</strong> Unauthorized copy, reproduction, or use of website material is prohibited.</p>

<h4><strong>23. PRIVACY &amp; DATA PROTECTION</strong></h4>
<p><strong>23.1</strong> Client data is collected and processed in accordance with the Company’s Privacy Policy.</p>
<p><strong>23.2</strong> By booking a tour, you consent to the processing and sharing of personal information with suppliers as required.</p>

<h4><strong>24. GOVERNING LAW &amp; JURISDICTION</strong></h4>
<p><strong>24.1</strong> These Terms are governed by the laws of India / Tamil Nadu.</p>
<p><strong>24.2</strong> Any disputes shall be subject to the exclusive jurisdiction of the courts in Madurai.</p>

<h4><strong>25. AMENDMENTS TO TERMS</strong></h4>
<p><strong>25.1</strong> The Company reserves the right to modify or update these Terms at any time without prior notice.</p>
<p><strong>25.2</strong> Continued use of services constitutes acceptance of updated Terms.</p>

<h4><strong>26. ACCEPTANCE OF TERMS</strong></h4>
<p><strong>26.1</strong> By confirming a booking, you agree to be governed by these Terms and any supplemental policies mentioned in your itinerary, invoice, or booking communication.</p>
<p><strong>26.2</strong> You accept all responsibilities arising from travel arrangements</p>
<p><strong>26.3</strong> If booking on behalf of others, you warrant that you are authorized to accept these Terms on their behalf.</p>
`;
  return (
    <footer
      className="footer"
      style={{ backgroundColor: '#e3f9f9', borderTop: '1px solid #e3f9f9' }}
    >
      <Container>
        <Row className="text-center text-md-start">

          {/* ---- LEFT SECTION ---- */}
          <Col md="5" className="mb-4">
            <img
              src={assets.logo}
              alt="Sha tours Logo"
              loading="lazy"
              style={{
                height: '140px',
                width: 'auto',
                marginBottom: '16px',
                objectFit: 'contain',
              }}
            />

            <div style={{ color: '#040695', lineHeight: '2' }}>
              <div className="d-flex align-items-center justify-content-md-start justify-content-center mb-2">
                <FiMail style={{ marginRight: '8px' }} />
                <a
                  href="mailto:badusha@shatoursindia.com"
                  style={{ color: '#040695', textDecoration: 'none' }}
                >
                  badusha@shatoursindia.com
                </a>
              </div>

              <div className="d-flex align-items-center justify-content-md-start justify-content-center">
                <FiPhone style={{ marginRight: '8px' }} />
                <a
                  href="tel:+919659760606"
                  style={{ color: '#040695', textDecoration: 'none' }}
                >
                  +91 96597 60606
                </a>
              </div>
            </div>
          </Col>

          {/* ---- CENTER MENU ---- */}
          <Col md="4" className="mb-4">
            <h4 style={{ color: '#040695', fontWeight: 'bold', marginBottom: '16px' }}>
              Menu
            </h4>

            <ul style={{ listStyle: 'none', padding: 0, lineHeight: '2', }}>
              <li><a href="/home" style={{ color: '#040695', textDecoration: 'none' }}>Home</a></li>
              <li><a href="/about" style={{ color: '#040695', textDecoration: 'none' }}>About</a></li>
              <li><a href="/services" style={{ color: '#040695', textDecoration: 'none' }}>Services</a></li>
              <li><a href="/contact" style={{ color: '#040695', textDecoration: 'none' }}>Contact</a></li>
              <li><a href="/faq" style={{ color: '#040695', textDecoration: 'none' }}>FAQ</a></li>
            </ul>
          </Col>

          {/* ---- RIGHT SOCIAL ---- */}
          <Col md="3">
            <h4 style={{ color: '#040695', fontWeight: 'bold', marginBottom: '16px' }}>
              Follow Us
            </h4>

            <div className="d-flex gap-3 justify-content-md-start justify-content-center">
              <a href="https://www.facebook.com/profile.php?id=61584082282265"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#040695', fontSize: '1.5rem' }}>
                <FiFacebook />
              </a>

              <a href="https://x.com/shatoursindia"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#040695', fontSize: '1.5rem' }}>
                <FaXTwitter />
              </a>

              <a href="https://www.instagram.com/shatoursindia"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#040695', fontSize: '1.5rem' }}>
                <FiInstagram />
              </a>

              <a href="https://www.linkedin.com/in/sha-tours-india-925294399"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#040695', fontSize: '1.5rem' }}>
                <FiLinkedin />
              </a>

              <a href="http://t.me/ShaToursIndia"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#040695', fontSize: '1.5rem' }}>
                <FaTelegramPlane />
              </a>
            </div>
          </Col>

        </Row>

        {/* COPYRIGHT */}
        <Row>
          <Col className="text-center">
            <p style={{ color: '#040695', margin: 0 }}>
              &copy; {new Date().getFullYear()} Sha Tours. All rights reserved |{' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleTerms();
                }}
                style={{ color: '#040695', textDecoration: 'none' }}
              >
                Terms & Conditions
              </a>{' '}
              |{' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  togglePrivacy();
                }}
                style={{ color: '#040695', textDecoration: 'none' }}
              >
                Privacy Policy
              </a>
            </p>
          </Col>
        </Row>
      </Container>

      {/* Terms Modal */}
      <Modal isOpen={termsModal} toggle={toggleTerms} size="lg" scrollable>
        <ModalHeader style={{color:'#040695'}} toggle={toggleTerms}>Terms & Conditions</ModalHeader>
        <ModalBody>
          <div dangerouslySetInnerHTML={{ __html: termsConditionsContent.replace(/\n/g, '<br />') }} />
        </ModalBody>
      </Modal>

      {/* Privacy Modal */}
      <Modal isOpen={privacyModal} toggle={togglePrivacy} size="lg" scrollable>
        <ModalHeader style={{color:'#040695'}} toggle={togglePrivacy}>Privacy Policy</ModalHeader>
        <ModalBody>
          <div dangerouslySetInnerHTML={{ __html: privacyPolicyContent.replace(/\n/g, '<br />') }} />
        </ModalBody>
      </Modal>
    </footer>
  );
};

export default Footer;
